import { USER_MANUAL_URL } from "@/data/url_list";
import { getBrowserLocaleCode } from "@/utils/date-util";
import { SATError, SATErrorType, SATResult } from "@sadtx/sat-error";

/**
 * 사용자 가이드(PDF) 다운로드(새 탭 열기) 유스케이스
 *
 * - 브라우저 팝업 차단 등으로 `window.open`이 null을 반환할 수 있으므로 성공/실패 결과를 반환한다.
 */
export class DownloadUserManualUsecase {
  constructor(
    private readonly getLocale: () => string | null | undefined = () => getBrowserLocaleCode(),
    private readonly userManual: (locale: string) => string = (locale) =>
      USER_MANUAL_URL.userManual(locale)
  ) {}

  execute(locale?: string | null): SATResult<void, SATError> {
    const resolvedLocale = locale ?? this.getLocale() ?? "ko";
    const url = this.userManual(resolvedLocale);
    const opened = window.open(url, "_blank");
    console.log("[DownloadUserManualUsecase] :: execute :: opened", opened);
    if (!opened) {
      return SATResult.failure(new SATError(SATErrorType.NetworkError, "팝업 차단 등으로 사용자 메뉴얼을 열 수 없습니다."));
    }
    return SATResult.success(void 0);
  }
}